export const DEFAULT_IN_ARTICLE_PROOF_URL =
    'https://www.usatoday.com/story/money/careers/2026/02/11/why-men-should-consider-becoming-a-nurse/104141678/';
